import { formatUnits } from 'viem'
import { UNIT } from '@/constants/wallet.js'
import { intervalToDuration } from 'date-fns'

export const numberFormatterOptions = {
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
  trailingZeroDisplay: 'stripIfInteger',
}

export const compactNumberFormatterOptions = {
  ...numberFormatterOptions,
  minimumFractionDigits: 0,
  notation: 'compact',
}

export const usdFormatterOptions = {
  currency: 'USD',
  currencyDisplay: 'symbol',
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
  style: 'currency',
  trailingZeroDisplay: 'stripIfInteger',
}

export const compactUsdFormatterOptions = {
  ...usdFormatterOptions,
  minimumFractionDigits: 0,
  notation: 'compact',
}

export const numberFormatter = Intl.NumberFormat(undefined, numberFormatterOptions)
export const compactNumberFormatter = Intl.NumberFormat(undefined, compactNumberFormatterOptions)

export const usdFormatter = Intl.NumberFormat(undefined, usdFormatterOptions)
export const compactUsdFormatter = Intl.NumberFormat(undefined, compactUsdFormatterOptions)

export const formatMweiAsUsd = x => usdFormatter.format(formatUnits(x, UNIT.MWEI))
export const formatMweiAsUsdCompact = x => compactUsdFormatter.format(formatUnits(x, UNIT.MWEI))

export const truncateAddress = x => `${x.slice(0, 10)}...${x.slice(-9)}`

export const durationFromDates = (startDate, endDate) => {
  const { days, hours, minutes, seconds } = intervalToDuration({
    end: endDate,
    start: startDate,
  })

  const hoursPadded = (hours ?? 0).toString().padStart(2, '0')
  const minutesPadded = (minutes ?? 0).toString().padStart(2, '0')
  const secondsPadded = (seconds ?? 0).toString().padStart(2, '0')

  if (days > 0) return `${days}:${hoursPadded}:${minutesPadded}:${secondsPadded}`
  if (hours > 0) return `${hoursPadded}:${minutesPadded}:${secondsPadded}`

  return `${minutesPadded}:${secondsPadded}`
}

export const durationFromSeconds = duration => durationFromDates(0, duration * 1000)

export const formatBytes = bytes => {
  const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB']
  let size = bytes
  let unitIndex = 0

  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024
    unitIndex++
  }

  return `${numberFormatter.format(size)}${units[unitIndex]}`
}
